import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Paper, Typography } from '@material-ui/core';
import moment from 'moment';
import 'moment/locale/ru';

const useStyles = makeStyles(theme => ({
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderColor: 'rgba(255, 255, 255, 0.23)',
        background: 'linear-gradient(to bottom, ' + theme.palette.primary.dark + ', ' + theme.palette.primary.light + ')',
    },
    colorBlack: {
        color: 'black',
        margin: '7px 7px'
    },
    colorRed: {
        color: '#cc00cc',
        margin: '7px 7px'
    }
}));

  
const SheduleDayHeader = props => {
    const { shift, timezone } = props;
    const classes = useStyles();

    //сб или вс
    const isRedDay = moment.unix(shift).utcOffset(timezone).day() === 0 || moment.unix(shift).utcOffset(timezone).day() === 6;

    return (
        <Paper variant="outlined" className={classes.header}>
            <Typography variant="h6" className={classes.colorBlack}>
                {moment.unix(shift).utcOffset(timezone).format("DD MMMM YYYY")}
            </Typography>
            <Typography variant="button" noWrap color="secondary">
                {moment.unix(shift).isSame(moment(), 'day') ? " СЕГОДНЯ" : ""}
            </Typography>
            <Typography variant="h4" align='center' className={isRedDay?classes.colorRed:classes.colorBlack}>
                {moment.unix(shift).utcOffset(timezone).format('ddd').toUpperCase()}
            </Typography>
        </Paper>
    );
}

SheduleDayHeader.propTypes = {
    shift :PropTypes.number,
    timezone: PropTypes.number,
};
  
export default SheduleDayHeader;